import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContributeButton from '../../../../../components/global/ContributeButton/ContributeButton';
import useOpenModal from '../../../../../hooks/useOpenModal';
import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import ListingCardTemplate from '../../../../pro/components/ListingCardTemplate';
import Button from '../../../../../components/global/Button';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../constants/modals';

const propTypes = {
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  ),
  thumbnailActions: PropTypes.node,
  title: PropTypes.string,
};

const WebGalleryEventListingCard = ({
  linkTo,
  onClick,
  album,
  thumbnails,
  className,
  thumbnailActions,
  title,
}) => {
  const openModal = useOpenModal();
  const thumbnailUrl = getThumbBySize(
    thumbnails ?? [],
    IMAGE_SIZE_CODE.MEDIUM2X,
    // Important for when using local cache
    true,
  )?.url;

  const classes = classNames({
    'album-card': true,
    'event-album-card': true,
    'with-thumbnail': !!thumbnailUrl,
    [className]: !!className,
  });

  const buttonContainerClasses = classNames({
    'listing-card-template-cover-null-state-actions-buttons': true,
  });

  return (
    <ListingCardTemplate
      className={classes}
      linkTo={linkTo}
      onClick={onClick}
      title={title ?? album?.name}
      thumbnailUrl={thumbnailUrl}
      thumbnailActions={thumbnailActions}
      note={
        <Fragment>
          {!thumbnailUrl && (
            <p className="text-normal">
              Got photos?
              <br />
              Add them now!
            </p>
          )}
          <div className={buttonContainerClasses}>
            <ContributeButton
              albumId={album?.id}
              btnBlock={!!thumbnailUrl}
              className="text-uppercase"
              btnStyle="white"
              btnOutline
              btnSize={thumbnailUrl ? 'sm' : 'xs'}
            >
              Upload
            </ContributeButton>
            <Button
              btnBlock={!!thumbnailUrl}
              className="text-uppercase"
              btnStyle="white"
              btnOutline
              btnSize={thumbnailUrl ? 'sm' : 'xs'}
              onClick={event => {
                event.preventDefault();
                openModal(CONTRIBUTOR_SHARE_MODAL);
              }}
            >
              Share
            </Button>
          </div>
        </Fragment>
      }
    />
  );
};

WebGalleryEventListingCard.propTypes = propTypes;

export default WebGalleryEventListingCard;
